import React, { useEffect, useContext, useState, useReducer } from "react";
import { useHistory } from "react-router-dom";
import {
  makeStyles,
  Grid,
  Typography,
  Collapse,
  RootRef,
  IconButton,
  useMediaQuery,
  useTheme,
  Button as MuiButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Box,
} from "@material-ui/core";
import SortIcon from "@material-ui/icons/Sort";
import {
  TextField,
  ProductCard,
  Paper,
  Loader,
  PopUp,
  Button,
  PaperOptions,
  Popover,
} from "../components";
import { doctorServices, labServices } from "../services";
import { AuthContext } from "../context";
import { SearchIcon, RecordIcon, GridIcon, CloseIcon } from "../icons";
import { modals } from "../constants";
import { useScroll, useResize, usePopover } from "../hooks";
import { FullscreenExitRounded, FullscreenRounded } from "@material-ui/icons";
export default function Dashboard({ loggedIn, ...props }) {
  //const { state } = useContext(AuthContext);
  const [viewList, setViewList] = useState(true);
  const { paperGrow, domRef, onScroll } = useScroll(100);
  const [imageLoaded, setImageLoaded] = useState(false);
  const { collapseH } = useResize(imageLoaded);
  const classes = useStyles({ viewList, paperGrow, collapseH, ...props })();
  const history = useHistory();
  const { authState, signOut } = useContext(AuthContext);
  const [query, setQuery] = useState("");
  const [modalName, setModalName] = useState("");
  const [modal, setModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [productToRequest, setProductToRequest] = useState(null);
  const [changeSize, setChangeSize] = useState(false);
  const [modalError, setModalError] = useState(false);
  const matchesDesktop = useMediaQuery(useTheme().breakpoints.up("md"));
  const { id, open, anchorEl, setAnchorEl } = usePopover();
  const [openMapModal, setOpenMapModal] = useState(false);
  const [isFullScreenActive, setIsFullScreenActive] = useState(false);
  const [products, dispatch] = useReducer((myArray, { type, value }) => {
    switch (type) {
      case "add":
        return [...myArray, value];
      case "remove":
        return myArray.filter((_, index) => index !== value);
      case "updateIsSelect":
        return myArray.map((element, index) => {
          if (index === value) {
            return {
              ...element,
              isSelect: !element.isSelect,
            };
          }
          return { ...element };
        });
      case "filterValues":
        return myArray.map((element, index) => {
          if (element.name.toLowerCase().includes(value.toLowerCase())) {
            return {
              ...element,
              show: !element.show,
            };
          }
          return { ...element };
        });
      case "orderBy":
        return myArray.sort(function (a, b) {
          if (value !== "assigned") {
            if (a[value].toLowerCase() > b[value].toLowerCase()) {
              return 1;
            }
            if (a[value].toLowerCase() < b[value].toLowerCase()) {
              return -1;
            }
            // a must be equal to b
            return 0;
          } else {
            const availableA = a.assigned - a.used;
            const availableB = b.assigned - b.used;
            if (availableA > availableB) {
              return 1;
            }
            if (availableA < availableB) {
              return -1;
            }
            // a must be equal to b
            return 0;
          }
        });
      default:
        return myArray;
    }
  }, []);

  useEffect(() => {
    async function init() {
      try {
        setLoading(true);
        const { status, response } = await doctorServices.getDoctorKit({
          token: authState.token,
          _id: authState.user.doctor._id,
        });
        // console.log("response", response)
        setLoading(false);
        if (status === 200) {
          // let productsSimplified = [];
          // response.products.forEach((p) => {
          //   let total_assigned = response.products
          //     .filter(({ _id }) => _id === p._id)
          //     .reduce((prev, curr) => prev + (curr.assigned - curr.used), 0);

          //   let existInProductsSimplified = productsSimplified.find(
          //     ({ _id }) => _id === p._id
          //   );

          //   // if (!existInProductsSimplified) {
          //   productsSimplified.push({
          //     [p.assigmentId]: {
          //       ...p,
          //     },
          //     assigned: total_assigned,
          //   });
          //   // }

          // });
          // console.log({ productsSimplified });
          // response.products = productsSimplified

          const orderArray = response.products.sort(function (a, b) {
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return 1;
            }
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return -1;
            }
            // a must be equal to b
            return 0;
          });

          orderArray.forEach((element, index) => {
            dispatch({
              type: "add",
              value: {
                ...element,
                isSelect: false,
                quantityToAssign: 1,
                index,
              },
            });
          });
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        setLoading(false);
        console.log("Error", e);
      }
    }
    init();
  }, [authState, signOut]);

  const updateIsSelect = async (index) => {
    dispatch({ type: "updateIsSelect", value: index });
  };

  const filterList = (value) => {
    if (value === "") {
      setFilter(false);
    }
    setQuery(value);
    setFilteredProducts(
      products.filter(
        (element, index) =>
          element.name.toLowerCase().includes(value.toLowerCase()) ||
          element.molecule.toLowerCase().includes(value.toLowerCase()) ||
          element.laboratory.name.toLowerCase().includes(value.toLowerCase()),
      ),
    );
    setFilter(true);
  };

  const requestSingleProduct = async (product) => {
    try {
      setModalError(false);
      setModal(false);
      setLoading(true);
      const { status, response } = await labServices.addOrder({
        products: [{ _id: product._id }],
        token: authState.user.token,
        doctorId: authState.user.doctor._id,
      });
      setLoading(false);
      if (status === 201) {
        setModalMessage(response.message);
      } else if (status === 401) {
        signOut();
      } else {
        if (response.error) {
          if (response.error.code === 1015) {
            setModalMessage(response.error.message);
            setModalError(true);
          }
        }
      }
      setModalName(modals[2]);
      setModal(true);
    } catch (e) {
      setLoading(false);
      console.log("Error", e);
    }
  };

  const orderList = async (index) => {
    setAnchorEl(null);
    setLoading(true);
    await dispatch({
      type: "orderBy",
      value: index === 0 ? "name" : index === 1 ? "molecule" : "assigned",
    });
    setLoading(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid container>
      <PopUp
        modalName={modalName}
        open={modal}
        setModal={() => setModal(!modal)}
        message={modalMessage}
        modalError={modalError}
        productToRequest={productToRequest}
        onClickSameLab={(product) => requestSingleProduct(product)}
        modalSubMessage={
          "Por favor debe estar atento de la confirmación de su pedido."
        }
      />
      {loading && <Loader loading={true} />}
      <Grid className={classes.container} container>
        <Collapse
          in={!matchesDesktop ? !paperGrow : true}
          timeout={250}
          style={{ width: "100%" }}
          id={"collapseId"}
        >
          <Grid className={classes.containerImage} container>
            <Grid item md={3} xs={6} sm={4}>
              <img
                style={{ aspectRatio: 1, width: "100%", maxWidth: "200px" }}
                src="../../assets/botiquin.svg"
                alt=""
                onLoad={() => setImageLoaded(true)}
              />
            </Grid>
            <Grid item xs={6} sm={8}>
              <Typography
                style={{ fontSize: "1rem", lineHeight: "1.1" }}
                component={"span"}
                variant={"h2"}
              >
                {authState.user?.doctor.gender === "FEMENINO"
                  ? "Bienvenida Dra."
                  : "Bienvenido Dr."}
                <br /> {authState.user.doctor.name}{" "}
                {authState.user.doctor.lastName}
              </Typography>
              {/* <Box style={{ width: 50, height: 50, marginLeft: "auto" }}>
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                  src="https://mcusercontent.com/6692d5e923cce4ced13516ecc/images/0aab6ded-bbc5-8da3-341f-aeb39266d8b5.png"
                  alt=""
                />
              </Box> */}
              <MuiButton
                variant="outlined"
                color="secondary"
                size="small"
                fullWidth
                style={{ borderRadius: 100, marginTop: 12 }}
                onClick={() => setOpenMapModal(true)}
              >
                Ruta Unio
              </MuiButton>
            </Grid>
            <Grid
              md={9}
              className={classes.desktopOptions}
              container
              justify="flex-start"
              alignItems="center"
              item
            >
              <Grid item md={12} container>
                <Grid item md={6}>
                  <Typography component="h1" variant="h1">
                    Botiquín
                  </Typography>
                </Grid>
                <Grid item md={6}>
                  <Typography
                    style={{ fontSize: "1rem", lineHeight: "1.1" }}
                    component={"p"}
                    variant={"h2"}
                  >
                    {authState.user?.doctor.gender === "FEMENINO"
                      ? "Bienvenida Dra."
                      : "Bienvenido Dr."}{" "}
                    {authState.user.doctor.name}{" "}
                    {authState.user.doctor.lastName}
                  </Typography>
                  {/* <Box
                    style={{
                      width: 50,
                      height: 50,
                      marginLeft: "auto",
                    }}
                  >
                    <img
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                      src="https://mcusercontent.com/6692d5e923cce4ced13516ecc/images/0aab6ded-bbc5-8da3-341f-aeb39266d8b5.png"
                      alt=""
                    />
                  </Box> */}
                  <MuiButton
                    variant="outlined"
                    color="secondary"
                    size="small"
                    fullWidth
                    style={{
                      borderRadius: 100,
                      marginBottom: "12px",
                      marginTop: "12px",
                    }}
                    onClick={() => setOpenMapModal(true)}
                  >
                    Ruta Unio
                  </MuiButton>
                </Grid>
              </Grid>

              <Grid
                item
                md={12}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                <Grid container justify="space-between" alignItems="center">
                  <Grid item md={8} style={{ position: "relative" }}>
                    <TextField
                      type={"text"}
                      name={"query"}
                      value={query}
                      placeholder={"¿Qué estás buscando?"}
                      fontWeight="bold"
                      style={{
                        justifyContent: "flex-end",
                      }}
                      showIcon
                      iconComponent={() => <SearchIcon onClick={() => {}} />}
                      onClickIcon={() => {}}
                      onChange={(e) => filterList(e.target.value)}
                    />
                  </Grid>
                  {
                    <Grid item md={4} container justify="flex-end">
                      <IconButton
                        aria-describedby={id}
                        onClick={handleClick}
                        style={{ width: 45, height: 45 }}
                      >
                        {" "}
                        <SortIcon style={{ color: "#2196C0" }} />{" "}
                      </IconButton>
                      <IconButton
                        onClick={() => setViewList(true)}
                        style={{
                          backgroundColor: viewList ? "#2196C0" : "unset",
                          width: 45,
                          height: 45,
                        }}
                      >
                        {" "}
                        <RecordIcon
                          color={viewList ? "white" : "#2196C0"}
                        />{" "}
                      </IconButton>
                      <IconButton
                        onClick={() => setViewList(false)}
                        style={{
                          backgroundColor: viewList ? "unset" : "#2196C0",
                          width: 45,
                          height: 45,
                        }}
                      >
                        {" "}
                        <GridIcon color={viewList ? "#2196C0" : "white"} />{" "}
                      </IconButton>
                    </Grid>
                  }
                </Grid>
                {/* {products.some((element) => element.isSelect) && ( */}
                <Grid
                  container
                  style={{
                    // position: "absolute",
                    // bottom: -50,
                    width: "60%",
                    marginTop: "16px",
                    height: products.some((element) => element.isSelect)
                      ? 50
                      : 0,
                    transition: "height 0.3s ease",
                  }}
                >
                  <Button
                    onClick={() =>
                      history.push({
                        pathname: "/assign",
                        state: { products },
                      })
                    }
                  >
                    {" "}
                    ASIGNAR A PACIENTE
                  </Button>
                </Grid>
                {/* )} */}
              </Grid>
            </Grid>
          </Grid>
        </Collapse>
        <Paper className={classes.paperClass}>
          <PaperOptions
            title={"Botiquín"}
            query={query}
            changeSize={changeSize}
            setChangeSize={(value) => setChangeSize(value)}
            viewList={viewList}
            setViewList={(value) => setViewList(value)}
            filterList={(e) => filterList(e)}
            orderList={(index) => orderList(index)}
            handleClickPopover={(event) => handleClick(event)}
          />
          <Popover
            id={id}
            disp
            open={open}
            anchorEl={anchorEl}
            handleClose={handleClose}
            orderList={(index) => orderList(index)}
          />
          <RootRef rootRef={domRef}>
            <Grid
              container
              spacing={2}
              className={classes.scrollList}
              /* onScroll={onScroll} */
            >
              {!products.length && (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  className={classes.emptyKit}
                  container
                  justify="center"
                  alignItems="center"
                  direction="column"
                >
                  <img src="../assets/work.svg" alt="" />
                  <Typography align="center">
                    Su Botiquín se <br /> encuentra vacío
                  </Typography>
                </Grid>
              )}
              {filter && !filteredProducts.length && (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  className={classes.emptyKit}
                  container
                  justify="center"
                  alignItems="center"
                  direction="column"
                >
                  <img src="../assets/danger-circle.svg" alt="" />
                  <Typography align="center">
                    Muestra <br /> no encontrada
                  </Typography>
                  <Typography align="center">
                    Por favor intente <br /> nuevamente
                  </Typography>
                </Grid>
              )}
              {products.length !== 0 &&
                !filter &&
                products.map((product, index) => {
                  if (product.status !== "661822407b4df03548c403fb") {
                    return (
                      <Grid
                        item
                        sm={viewList ? 12 : 3}
                        xs={viewList ? 12 : 6}
                        key={index}
                      >
                        {
                          <ProductCard
                            viewList={viewList}
                            hideListQuantity
                            product={product}
                            productsList={products}
                            onClickSelect={() => updateIsSelect(index)}
                            onClickRequest={() => {
                              setModal(!modal);
                              setProductToRequest(product);
                              setModalName(modals[3]);
                            }}
                          />
                        }
                      </Grid>
                    );
                  }
                  return null;
                })}
              {products.length !== 0 &&
                filter &&
                filteredProducts.map((product, index) => (
                  <Grid item sm={12} xs={viewList ? 12 : 6} key={index}>
                    {
                      <ProductCard
                        viewList={viewList}
                        hideListQuantity
                        product={product}
                        productsList={products}
                        onClickSelect={() => updateIsSelect(product.index)}
                        onClickRequest={() => {
                          setModal(!modal);
                          setProductToRequest(product);
                          setModalName(modals[3]);
                        }}
                      />
                    }
                  </Grid>
                ))}
            </Grid>
          </RootRef>
        </Paper>
      </Grid>
      {!matchesDesktop && products.some((element) => element.isSelect) && (
        <Grid container className={classes.containerBtn}>
          <Button
            onClick={() =>
              history.push({ pathname: "/assign", state: { products } })
            }
          >
            {" "}
            ASIGNAR A PACIENTE
          </Button>
        </Grid>
      )}
      {openMapModal && (
        <Dialog
          fullScreen={isFullScreenActive}
          open={openMapModal}
          onClose={() => {
            setOpenMapModal(false);
            setIsFullScreenActive(false);
          }}
          aria-labelledby="ejemplo: Mapa de puntos de entrega"
        >
          <DialogActions>
            <IconButton
              onClick={() => {
                setOpenMapModal(false);
                setIsFullScreenActive(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
          <DialogContent style={{ position: "relative", padding: 8 }}>
            <IconButton
              className={classes.fullScreenButton}
              onClick={() => setIsFullScreenActive((prev) => !prev)}
            >
              {isFullScreenActive ? (
                <FullscreenExitRounded />
              ) : (
                <FullscreenRounded />
              )}
            </IconButton>
            <img
              style={{ width: "100%", aspectRatio: "4/6" }}
              src="/mapa_muestras_medicas.png"
              alt="Mapa de puntos de entrega de muestras médicas"
            />
          </DialogContent>
        </Dialog>
      )}
    </Grid>
  );
}

const useStyles = ({ viewList, paperGrow, collapseH, ...props }) =>
  makeStyles((theme) => ({
    container: {
      display: "block",
      height: "100vh",
      "@supports (height: 100dvh)": {
        height: "100dvh",
      },
      overflowY: "auto", // Añadido
      [theme.breakpoints.up("md")]: {
        padding: "50px 50px 0 50px",
        height: "100%",
      },
    },
    popover: {
      width: 190,
      height: 150,
      borderRadius: 16,
      padding: 10,
      flexDirection: "column",
      display: "flex",
    },
    containerBtn: {
      position: "fixed",
      bottom: "calc(90px + env(safe-area-inset-bottom, 0px))",
      padding: "0 12px",
      zIndex: 3,
    },
    emptyKit: {
      height: "100%",
      "& p": {
        color: "#C4C4C4",
        fontWeight: "bold",
      },
      "& p:nth-child(2)": {
        fontSize: "1.5rem",
        lineHeight: "1.813rem",
        margin: "30px 0 0 0",
      },
      "& p:nth-child(3)": {
        margin: "10px 0 0 0",
      },
    },
    desktopOptions: {
      display: "none",
      padding: "0 0 0 40px",
      height: "100%",
      position: "relative",
      // "& > div:nth-child(1)": {
      //   height: "40%",
      // },
      // "& > div:nth-child(2)": {
      //   height: "60%",
      // },
      [theme.breakpoints.up("md")]: {
        display: "flex",
        // height: "150px",
        height: "250px",
      },
    },
    paperClass: {
      height: paperGrow ? "100%" : "calc(100% - 127px)",
      [theme.breakpoints.up("md")]: {
        height: `calc(100% - ${collapseH}px)`,
      },
    },
    scrollList: {
      height: "calc(100% - 65.66px)",
      [theme.breakpoints.up("md")]: {
        height: "98%",
      },
      [theme.breakpoints.down("sm")]: {
        "&::-webkit-scrollbar": {
          width: "1px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(0,0,0, .1)",
        },
      },
      overflowY: "scroll",
      display: viewList ? "block" : "flex",
      paddingTop: 0,
      paddingBottom:
        "calc(150px + env(safe-area-inset-bottom, 0px)) !important",
      width: "100%",
      margin: 0,
      "&::-webkit-scrollbar": {
        width: "4px",
        height: "8px",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.secondary.main,
        borderRadius: "10px",
      },
    },
    containerImage: {
      alignItems: "flex-start",
      padding: "5px 25px 9px 45px",
      height: "100%",
      "& div:nth-child(1)": {
        "& img": {
          [theme.breakpoints.up("md")]: {
            width: "100%",
          },
        },
      },
      "& > div:nth-child(2)": {
        height: "100%",
        paddingLeft: 5,
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        gap: 2,
        [theme.breakpoints.up("md")]: {
          display: "none",
        },
      },
      [theme.breakpoints.up("md")]: {
        alignItems: "center",
        padding: "0 0 0 8px",
      },
    },
    fullScreenButton: {
      position: "absolute",
      backgroundColor: "rgb(255 255 255 / 94%)",
      backdropFilter: " blur(1px)",
      right: "5%",
      top: "5%",
      borderRadius: 2,
      padding: 2,
      [theme.breakpoints.up("md")]: {
        padding: "10px",
      },
      "&:hover": {
        backgroundColor: "#fff",
      },
    },
  }));
